import React from 'react';
import _isString from 'lodash/isString';
import _isArray from 'lodash/isArray';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';

import ButtonsRow from 'components/ButtonsRow';
import Typography from 'components/Typography';
import { ExpansionButton } from 'components/Button';

import HorizontalDivider from '../HorizontalDivider';

import Styled from './styles';

const TYPOGRAPHY_CONFIG: {
  style?: React.CSSProperties;
  variant: 'CAPTION'
} = {
  style: { padding: Tokens.SPACING.SPACING_24 },
  variant: 'CAPTION'
};

const BUTTONS_ROW_STYLE = {
  padding: Tokens.SPACING.SPACING_0
};

export interface AlertDetailsProps extends React.ComponentPropsWithRef<'div'> {
  /** Set `true`, to render the expanded state. */
  expanded: boolean;
  /** <ExpansionButton /> configuration. See <ExpansionButton /> documentation for more information. */
  expansionButtonProps: {
    onExpansionChange: (args: boolean) => void,
    collapsedTitle?: React.ReactNode,
    expandedTitle?: React.ReactNode,
    theme?: Record<string, unknown>
  };
  /** The content of the expanded area, can be string or a node. */
  expandedMessage: React.ReactNode;
  /** An array of the `<Button/>` component, or alternatively a node. */
  buttons?: React.ReactNode[] | React.ReactNode;
}

/** All other props will be passed to the wrapper element. */
const AlertDetails = (props: AlertDetailsProps) => {
  const {
    buttons,
    expansionButtonProps,
    expandedMessage,
    expanded,
    ...otherProps
  } = props;

  const resolvedContent = _isString(expandedMessage)
    ? <Typography {...TYPOGRAPHY_CONFIG}>{expandedMessage}</Typography>
    : expandedMessage;

  return (
    <div {...otherProps}>
      <Styled.AlertDetailsHeader>
        <ExpansionButton expanded={expanded} {...expansionButtonProps} />
        {!!buttons && _isArray(buttons) ? <ButtonsRow style={BUTTONS_ROW_STYLE}>{buttons}</ButtonsRow> : buttons}
      </Styled.AlertDetailsHeader>
      {!!expanded && <HorizontalDivider />}
      {!!expanded && resolvedContent}
    </div>
  );
};

AlertDetails.displayName = 'AlertDetails';

AlertDetails.defaultProps = {
  buttons: undefined
};

export default AlertDetails;